import styled, { keyframes, css } from 'styled-components'

import React from 'react'
import { IOS_DEVICE } from 'constants/global.constants'

const iOS = IOS_DEVICE.test(navigator.userAgent)
interface PropsContainer {
  isOpen: boolean
  disabled?: boolean
  children?: React.ReactNode
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`

export const CompanyName = styled.p<{ isOpen: boolean }>`
  margin: 8px 0 4px;
  font-size: 14px;
  font-weight: 500;
  color: #5b6b7a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 12px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const Welcome = styled.div<PropsContainer>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 0 0 18px;
  padding: 4px 10px 18px;
  border-bottom: 1px solid #e4edf4;
  opacity: 0;
  text-align: left;
  animation: ${(props) =>
    props.isOpen
      ? css`
          ${fadeIn} 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards
        `
      : 'none'};
`

export const UserAvatar = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eaf2f9;
  color: #2d749c;
  font-family: 'Public Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
`

export const UserName = styled.div`
  overflow: hidden;
  flex: 1;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
`

export const ResponsiveHeaderContainer = styled.div`
  @media (min-width: 992px) {
    display: none;
  }
  @media (max-width: 992px) {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(14px);
    width: -webkit-fill-available;
    height: 48px;
    padding: 12px 14px;
    box-shadow: 0 8px 28px rgba(23, 55, 77, 0.08);
    z-index: 999;
  }
`
export const ResponsiveHeader = styled.div`
  @media (min-width: 992px) {
    display: none;
  }
  @media (max-width: 992px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: inherit;
  }
`
export const SideBar = styled.div<PropsContainer>`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  color: #163247;
  min-width: ${(props) => (props.isOpen ? '280px' : '76px')};
  width: ${(props) => (props.isOpen ? '280px' : '76px')};
  height: 100vh;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-right: 1px solid #d7e0ea;
  box-shadow: 4px 0 20px rgba(23, 55, 77, 0.04);
  @media (max-width: 992px) {
    visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
    display: ${(props) => (props.isOpen ? 'block' : 'none')};
    opacity: ${(props) => (props.isOpen ? '1' : '0')};
    z-index: 998;
    width: min(280px, 82vw);
    min-width: min(280px, 82vw);
    animation: ${(props) =>
      props.isOpen
        ? css`
            ${slideIn} 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards
          `
        : 'none'};
  }

  ${iOS &&
  css`
    position: fixed;
    height: 100dvh;
  `}
`
export const SidebarHeader = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 92px;
  width: 100%;
  padding: 20px 18px 10px;
`
export const SidebarHeaderContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  min-height: 64px;
`

export const SidebarBrand = styled.div<PropsContainer>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  padding: 0 42px;
  transform: translateY(-8px);

  @media (max-width: 992px) {
    padding: 0 24px;
  }
`
export const HeaderContentItem = styled.svg`
  cursor: pointer;
`
export const HeaderContentItemCollapseIcon = styled.svg<PropsContainer>`
  padding: 6px;
  border-radius: 10px;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(45, 116, 156, 0.08);
  }

  @media (max-width: 992px) {
    margin-left: ${(props) => (props.isOpen ? '150px' : '0px')};
    cursor: pointer;
  }
`

export const HeaderContentItemLogo = styled.svg`
  @media (max-width: 992px) {
    margin-right: 20px;
  }
`
export const HeaderContentItemBluesiteLogo = styled.svg<PropsContainer>`
  @media (max-width: 992px) {
    display: ${(props) => (props.isOpen ? 'none' : 'none')};
  }
`

export const CollapseIcon = styled.div<PropsContainer>`
  transform: ${(props) => (props.isOpen ? 'rotate(0)' : 'rotate(180deg)')};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%) ${(props) => (props.isOpen ? 'rotate(0)' : 'rotate(180deg)')};
`

export const RightSectionHeader = styled.div`
  display: flex;
  align-items: center;
  height: inherit;
  column-gap: 14px;
  height: 30px;
`

export const SidebarContent = styled.div`
  box-sizing: border-box;
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  overflow: hidden;
  color: #163247;
  padding: 0 18px 0;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2d749c;
    border-radius: 10px;
    border: 1px solid #2d749c;
    cursor: pointer;
  }
`

export const sidebarItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
`
export const LinksContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: #f4f8fb;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #9eb8c9;
    border-radius: 8px;
    border: 1px solid #f4f8fb;
  }
  gap: 3px;
  margin-top: 0;

  a {
    color: inherit;
  }

  a.active > div {
    background: #edf5fb;
    color: #1f638a;
    box-shadow: none;
    border-color: transparent;
    font-weight: 700;
  }

  a.active svg,
  a.active div {
    fill: #245d7d;
    color: #245d7d;
  }
`
export const SectionLabel = styled.div<PropsContainer>`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  margin: 8px 10px 3px;
  color: #7a8d9f;
  font-family: 'Public Sans', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`

export const SectionGroup = styled.div<PropsContainer>`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SidebarFooter = styled.div`
  flex: 0 0 auto;
  box-sizing: border-box;
  padding-top: 6px;
  padding-bottom: 6px;
  background: #ffffff;
`

export const LinkItem = styled.div`
  min-height: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  font-weight: 500;
  gap: 12px;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid transparent;
  position: relative;
  transition: background-color 0.18s ease, color 0.18s ease;

  :hover {
    background: rgba(45, 116, 156, 0.06);
    border-color: transparent;
  }
`
export const LinkItemTwo = styled.div`
  min-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 12px;
  font-weight: 500;
  gap: 12px;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid transparent;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  :hover {
    background: rgba(45, 116, 156, 0.06);
    border-color: #d7e0ea;
    box-shadow: 0 8px 18px rgba(45, 116, 156, 0.08);
  }
  &.disabled {
    cursor: default;
    background: none;
    box-shadow: none;
    border-color: transparent;
    color: #9aa7b3;
    font-weight: normal;
    fill: #9aa7b3;
  }
`

export const OptionItem = styled.div`
  min-height: 38px;
  display: flex;
  gap: 12px;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  font-weight: 600;
  cursor: pointer;
  color: #163247;
  border-radius: 10px;

`
export const LinkLogOut = styled.a<PropsContainer>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  margin-left: 10px;
  text-align: justify;
  font-size: 14px;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
`

export const Divider = styled.div`
  margin: 0 0 8px;
  min-height: 1px;
  border-top: 1px solid #e4edf4;
`
export const LogOut = styled.div`
  box-sizing: border-box;
  min-height: 36px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 12px;
  color: #ef2b2d;
  cursor: pointer;
  margin-bottom: 0;
  border-radius: 10px;
  border: 1px solid transparent;
  background: transparent;
  transition: background-color 0.18s ease;

  &:hover {
    background: rgba(239, 43, 45, 0.08);
  }
`
export const LinkIcon = styled.svg<PropsContainer>`
  position: ${(props) => (props.isOpen ? 'static' : 'absolute')};
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  fill: currentColor;
  color: #1f2124;

  :hover {
    color: currentColor;
    fill: currentColor;
  }
`
export const LinkIconTwo = styled.svg<PropsContainer>`
  position: ${(props) => (props.isOpen ? 'static' : 'absolute')};
  width: 24px;
  height: 24px;
  color: ${(props) => (props.disabled ? '#999' : 'initial')};

  :hover {
    color: ${(props) => (props.disabled ? '#999' : '#c6016b')};
    fill: ${(props) => (props.disabled ? '#999' : '#c6016b')};
    font-weight: ${(props) => (props.disabled ? 'normal' : 'bold')};
    pointer-events: none;
  }
`

export const TeamDevelopmentIcon = styled.div<{ url?: string }>`
  mask: url('${({ url }) => url}') no-repeat 0px 0px / cover;
  mask-size: 100% 100%;
  background-color: currentColor;
  height: 24px;
  width: 24px;
`

export const LinkItemThree = styled.div`
  min-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  font-weight: 500;
  gap: 12px;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid transparent;
  position: relative;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  :hover {
    background: rgba(45, 116, 156, 0.06);
    border-color: #d7e0ea;
    box-shadow: 0 8px 18px rgba(45, 116, 156, 0.08);
    transform: translateY(-1px);
  }
`

export const LinkIconThree = styled.div<PropsContainer>`
  position: ${(props) => (props.isOpen ? 'static' : 'absolute')};
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const LinkLogOutIcon = styled.svg<PropsContainer>`
  position: ${(props) => (props.isOpen ? 'static' : 'absolute')};
  height: 24px;
  width: 24px;
  fill: currentColor;
  color: currentColor;
`
export const Anchor = styled.div<PropsContainer>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  text-align: left;
  font-size: 14px;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 1.15;
`
const StyledAnchor = styled.div<PropsContainer>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  text-align: left;
  font-size: 14px;
  transition: width 0.5s ease-in-out;
  width: 100%;
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
`

export const AnchorFunction: React.FunctionComponent<PropsContainer> = ({ isOpen, disabled, children }) => {
  return React.createElement(StyledAnchor, { isOpen, disabled }, children)
}

export const SubContent = styled.div<PropsContainer>`
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  flex-direction: row;
  margin-left: 22px;
  width: 100%;
  overflow: hidden;
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 2px 0;
  margin: 0 0 4px;
`
export const LinkSubContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`
export const Line = styled.hr<PropsContainer>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  margin-left: 10px;
  margin-right: 14px;
  border: 0;
  width: 2px;
  background: #a8c5d9;
  border-radius: 2px;
`
export const LinkItemSubContent = styled.div`
  min-height: 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 6px 14px;
  font-weight: 600;
  margin-left: 0;
  cursor: pointer;
  border-radius: 10px;
  position: relative;
  border: 1px solid transparent;
  transition: background-color 0.18s ease, border-color 0.18s ease;

  :hover {
    background: #f5f9fc;
    border-color: transparent;
  }
`

export const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Public Sans', sans-serif;
  font-size: 12px;
  font-weight: 700;
  background: linear-gradient(135deg, #6cd72c 0%, #55b91e 100%);
  color: #ffffff;
  min-height: 20px;
  border-radius: 999px;
  padding: 0 8px;
  box-shadow: 0 10px 18px rgba(96, 204, 30, 0.2);
`
